export const STYLING_CONFIGS = {
  ROOT_SIZE: 16,
  HEADER_HEIGHT: 48,
  SIDEBAR_WIDTH: 250,
  BORDER_RADIUS: 6,
  TABLE_SCROLL_BREAKPOINT: 800,
  TABLE_IMAGE_HEIGHT: 40,
  TABLE_PAGE_SIZE: 10,
};
